import * as React from 'react';

import { FormFooterComponent, LogoComponent, VerificationService } from '@sheerid/jslib';

interface StepSuccessProps {
    verificationService: VerificationService;
}

const StepSuccessComponent = ({ verificationService }: StepSuccessProps) => {
    return (
        <div id="sid-step-success" className="sid-l-container">
            <div className="sid-header">
                <div className="sid-l-horz-center">
                     <LogoComponent verificationService={verificationService} />
                </div>
                <div className="sid-header__title sid-l-space-top-lg">
                    Success
                </div>
                <p className="sid-header__subtitle">
                    We’ve confirmed your student status. You’ll see the discount applied to eligible items when logged into your account.
                </p>
            </div>

            <div className="sid-l-space-top-none">
                <a href="https://www.madewell.com" target="_blank">Now let's shop (!)</a>
            </div>

            <div className="sid-footer sid-l-space-top-md sid-h-small-text">
                <FormFooterComponent verificationService={verificationService} />
            </div>
        </div>
    );
};


export { StepSuccessComponent };
